import { fromJS } from 'immutable';
import { basicSort } from '../../../util/sortUtils';
import { sort } from '../data/referenceReduxConstants';

export const REFERENCE_SEARCH_REQUEST = 'REFERENCE_SEARCH_REQUEST';
export const REFERENCE_SEARCH_SUCCESS = 'REFERENCE_SEARCH_SUCCESS';
export const REFERENCE_SEARCH_FAILURE = 'REFERENCE_SEARCH_FAILURE';

export const REFERENCE_SEARCH_CLEAR = 'REFERENCE_SEARCH_CLEAR';
export const REFERENCE_SEARCH_CLEAR_REDIRECT = 'REFERENCE_SEARCH_CLEAR_REDIRECT';

export const REFERENCE_HAVE_REQUEST = 'REFERENCE_HAVE_REQUEST';
export const REFERENCE_HAVE_SUCCESS = 'REFERENCE_HAVE_SUCCESS';
export const REFERENCE_HAVE_FAILURE = 'REFERENCE_HAVE_FAILURE';

export const REFERENCE_SEARCH_EQ_REGION_REQUEST = 'REFERENCE_SEARCH_EQ_REGION_REQUEST';
export const REFERENCE_SEARCH_EQ_REGION_SUCCESS = 'REFERENCE_SEARCH_EQ_REGION_SUCCESS';
export const REFERENCE_SEARCH_EQ_REGION_FAILURE = 'REFERENCE_SEARCH_EQ_REGION_FAILURE';

export const REFERENCE_SEARCH_EQ_COUNTRY_REQUEST = 'REFERENCE_SEARCH_EQ_COUNTRY_REQUEST';
export const REFERENCE_SEARCH_EQ_COUNTRY_SUCCESS = 'REFERENCE_SEARCH_EQ_COUNTRY_SUCCESS';
export const REFERENCE_SEARCH_EQ_COUNTRY_FAILURE = 'REFERENCE_SEARCH_EQ_COUNTRY_FAILURE';

export const REFERENCE_SEARCH_EQ_AREA_REQUEST = 'REFERENCE_SEARCH_EQ_AREA_REQUEST';
export const REFERENCE_SEARCH_EQ_AREA_SUCCESS = 'REFERENCE_SEARCH_EQ_AREA_SUCCESS';
export const REFERENCE_SEARCH_EQ_AREA_FAILURE = 'REFERENCE_SEARCH_EQ_AREA_FAILURE';

export const REFERENCE_SEARCH_VOL_COUNTRY_REQUEST = 'REFERENCE_SEARCH_VOL_COUNTRY_REQUEST';
export const REFERENCE_SEARCH_VOL_COUNTRY_SUCCESS = 'REFERENCE_SEARCH_VOL_COUNTRY_SUCCESS';
export const REFERENCE_SEARCH_VOL_COUNTRY_FAILURE = 'REFERENCE_SEARCH_VOL_COUNTRY_FAILURE';

export const REFERENCE_SEARCH_VOL_REGION_REQUEST = 'REFERENCE_SEARCH_VOL_REGION_REQUEST';
export const REFERENCE_SEARCH_VOL_REGION_SUCCESS = 'REFERENCE_SEARCH_VOL_REGION_SUCCESS';
export const REFERENCE_SEARCH_VOL_REGION_FAILURE = 'REFERENCE_SEARCH_VOL_REGION_FAILURE';

export const REFERENCE_SEARCH_VOL_VOLCANO_NAMES_REQUEST = 'REFERENCE_SEARCH_VOL_VOLCANO_NAMES_REQUEST';
export const REFERENCE_SEARCH_VOL_VOLCANO_NAMES_SUCCESS = 'REFERENCE_SEARCH_VOL_VOLCANO_NAMES_SUCCESS';
export const REFERENCE_SEARCH_VOL_VOLCANO_NAMES_FAILURE = 'REFERENCE_SEARCH_VOL_VOLCANO_NAMES_FAILURE';

export const REFERENCE_SEARCH_VOL_MORPHOLOGIES_REQUEST = 'REFERENCE_SEARCH_VOL_MORPHOLOGIES_REQUEST';
export const REFERENCE_SEARCH_VOL_MORPHOLOGIES_SUCCESS = 'REFERENCE_SEARCH_VOL_MORPHOLOGIES_SUCCESS';
export const REFERENCE_SEARCH_VOL_MORPHOLOGIES_FAILURE = 'REFERENCE_SEARCH_VOL_MORPHOLOGIES_FAILURE';

export const REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_REQUEST = 'REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_REQUEST';
export const REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_SUCCESS = 'REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_SUCCESS';
export const REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_FAILURE = 'REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_FAILURE';

export const REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_REQUEST = 'REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_REQUEST';
export const REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_SUCCESS = 'REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_SUCCESS';
export const REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_FAILURE = 'REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_FAILURE';

export const REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST = 'REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST';
export const REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_SUCCESS = 'REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_SUCCESS';
export const REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_FAILURE = 'REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_FAILURE';

export const REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_REQUEST = 'REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_REQUEST';
export const REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_SUCCESS = 'REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_SUCCESS';
export const REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_FAILURE = 'REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_FAILURE';

export const REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_REQUEST = 'REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_REQUEST';
export const REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_SUCCESS = 'REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_SUCCESS';
export const REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_FAILURE = 'REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_FAILURE';

export const REFERENCE_SEARCH_TSUNAMI_REGIONS_REQUEST = 'REFERENCE_SEARCH_TSUNAMI_REGIONS_REQUEST';
export const REFERENCE_SEARCH_TSUNAMI_REGIONS_SUCCESS = 'REFERENCE_SEARCH_TSUNAMI_REGIONS_SUCCESS';
export const REFERENCE_SEARCH_TSUNAMI_REGIONS_FAILURE = 'REFERENCE_SEARCH_TSUNAMI_REGIONS_FAILURE';

export const REFERENCE_SEARCH_TSUNAMI_COUNTRIES_REQUEST = 'REFERENCE_SEARCH_TSUNAMI_COUNTRIES_REQUEST';
export const REFERENCE_SEARCH_TSUNAMI_COUNTRIES_SUCCESS = 'REFERENCE_SEARCH_TSUNAMI_COUNTRIES_SUCCESS';
export const REFERENCE_SEARCH_TSUNAMI_COUNTRIES_FAILURE = 'REFERENCE_SEARCH_TSUNAMI_COUNTRIES_FAILURE';

export const REFERENCE_SEARCH_TSUNAMI_AREAS_REQUEST = 'REFERENCE_SEARCH_TSUNAMI_AREAS_REQUEST';
export const REFERENCE_SEARCH_TSUNAMI_AREAS_SUCCESS = 'REFERENCE_SEARCH_TSUNAMI_AREAS_SUCCESS';
export const REFERENCE_SEARCH_TSUNAMI_AREAS_FAILURE = 'REFERENCE_SEARCH_TSUNAMI_AREAS_FAILURE';

export const REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_REQUEST = 'REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_REQUEST';
export const REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_SUCCESS = 'REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_SUCCESS';
export const REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_FAILURE = 'REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_FAILURE';

export const REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_REQUEST = 'REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_REQUEST';
export const REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_SUCCESS = 'REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_SUCCESS';
export const REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_FAILURE = 'REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_FAILURE';

export const REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_REQUEST = 'REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_REQUEST';
export const REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_SUCCESS = 'REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_SUCCESS';
export const REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_FAILURE = 'REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_FAILURE';

export const REFERENCE_SEARCH_TSUNAMI_VALIDITIES_REQUEST = 'REFERENCE_SEARCH_TSUNAMI_VALIDITIES_REQUEST';
export const REFERENCE_SEARCH_TSUNAMI_VALIDITIES_SUCCESS = 'REFERENCE_SEARCH_TSUNAMI_VALIDITIES_SUCCESS';
export const REFERENCE_SEARCH_TSUNAMI_VALIDITIES_FAILURE = 'REFERENCE_SEARCH_TSUNAMI_VALIDITIES_FAILURE';

export const REFERENCE_SEARCH_TSUNAMI_CAUSES_REQUEST = 'REFERENCE_SEARCH_TSUNAMI_CAUSES_REQUEST';
export const REFERENCE_SEARCH_TSUNAMI_CAUSES_SUCCESS = 'REFERENCE_SEARCH_TSUNAMI_CAUSES_SUCCESS';
export const REFERENCE_SEARCH_TSUNAMI_CAUSES_FAILURE = 'REFERENCE_SEARCH_TSUNAMI_CAUSES_FAILURE';

export const REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_REQUEST = 'REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_REQUEST';
export const REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_SUCCESS = 'REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_SUCCESS';
export const REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_FAILURE = 'REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_FAILURE';

export const REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_REQUEST = 'REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_REQUEST';
export const REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_SUCCESS = 'REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_SUCCESS';
export const REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_FAILURE = 'REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_FAILURE';

export const REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_REQUEST = 'REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_REQUEST';
export const REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_SUCCESS = 'REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_SUCCESS';
export const REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_FAILURE = 'REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_FAILURE';

export const REFERENCE_SEARCH_DEPOSIT_COUNTRIES_REQUEST = 'REFERENCE_SEARCH_DEPOSIT_COUNTRIES_REQUEST';
export const REFERENCE_SEARCH_DEPOSIT_COUNTRIES_SUCCESS = 'REFERENCE_SEARCH_DEPOSIT_COUNTRIES_SUCCESS';
export const REFERENCE_SEARCH_DEPOSIT_COUNTRIES_FAILURE = 'REFERENCE_SEARCH_DEPOSIT_COUNTRIES_FAILURE';

export const REFERENCE_SEARCH_RUNUP_REGIONS_REQUEST = 'REFERENCE_SEARCH_RUNUP_REGIONS_REQUEST';
export const REFERENCE_SEARCH_RUNUP_REGIONS_SUCCESS = 'REFERENCE_SEARCH_RUNUP_REGIONS_SUCCESS';
export const REFERENCE_SEARCH_RUNUP_REGIONS_FAILURE = 'REFERENCE_SEARCH_RUNUP_REGIONS_FAILURE';

export const REFERENCE_SEARCH_RUNUP_COUNTRIES_REQUEST = 'REFERENCE_SEARCH_RUNUP_COUNTRIES_REQUEST';
export const REFERENCE_SEARCH_RUNUP_COUNTRIES_SUCCESS = 'REFERENCE_SEARCH_RUNUP_COUNTRIES_SUCCESS';
export const REFERENCE_SEARCH_RUNUP_COUNTRIES_FAILURE = 'REFERENCE_SEARCH_RUNUP_COUNTRIES_FAILURE';

export const REFERENCE_SEARCH_RUNUP_AREAS_REQUEST = 'REFERENCE_SEARCH_RUNUP_AREAS_REQUEST';
export const REFERENCE_SEARCH_RUNUP_AREAS_SUCCESS = 'REFERENCE_SEARCH_RUNUP_AREAS_SUCCESS';
export const REFERENCE_SEARCH_RUNUP_AREAS_FAILURE = 'REFERENCE_SEARCH_RUNUP_AREAS_FAILURE';

export const REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_REQUEST = 'REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_REQUEST';
export const REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_SUCCESS = 'REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_SUCCESS';
export const REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_FAILURE = 'REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_FAILURE';

export const REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_REQUEST = 'REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_REQUEST';
export const REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_SUCCESS = 'REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_SUCCESS';
export const REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_FAILURE = 'REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_FAILURE';

export const REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_REQUEST = 'REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_REQUEST';
export const REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_SUCCESS = 'REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_SUCCESS';
export const REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_FAILURE = 'REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_FAILURE';

export const REFERENCE_SEARCH_RUNUP_CAUSES_REQUEST = 'REFERENCE_SEARCH_RUNUP_CAUSES_REQUEST';
export const REFERENCE_SEARCH_RUNUP_CAUSES_SUCCESS = 'REFERENCE_SEARCH_RUNUP_CAUSES_SUCCESS';
export const REFERENCE_SEARCH_RUNUP_CAUSES_FAILURE = 'REFERENCE_SEARCH_RUNUP_CAUSES_FAILURE';

export const REFERENCE_SEARCH_RUNUP_VALIDITIES_REQUEST = 'REFERENCE_SEARCH_RUNUP_VALIDITIES_REQUEST';
export const REFERENCE_SEARCH_RUNUP_VALIDITIES_SUCCESS = 'REFERENCE_SEARCH_RUNUP_VALIDITIES_SUCCESS';
export const REFERENCE_SEARCH_RUNUP_VALIDITIES_FAILURE = 'REFERENCE_SEARCH_RUNUP_VALIDITIES_FAILURE';

export const REFERENCE_DATA_SORT = 'REFERENCE_DATA_SORT';

const initialState = fromJS({
  searching: false,
  fetched: false,
  references: [],
  queryParameters: {},
  searchRedirect: false,
  fetchedHaves: false,
  haves: [],

  // Associated Hazards
  eqFetchedCountries: false,
  eqCountries: [],
  eqFetchedRegions: false,
  eqRegions: [],
  eqFetchingAreas: false,
  eqAreas: [],

  volFetchedCountries: false,
  volCountries: [],
  volFetchedRegions: false,
  volRegions: [],
  volFetchedVolcanoNames: false,
  volVolcanoNames: [],
  volFetchedMorphologies: false,
  volMorphologies: [],

  volLocFetchedRegions: false,
  volLocRegions: [],
  volLocFetchedCountries: false,
  volLocCountries: [],
  volLocFetchedMorphologies: false,
  volLocMorphologies: [],
  volLocFetchedStatuses: false,
  volLocStatuses: [],
  volLocFetchedEruptionTimes: false,
  volLocEruptionTimes: [],

  tsuFetchedRegions: false,
  tsuRegions: [],
  tsuFetchedCountries: false,
  tsuCountries: [],
  tsuFetchingAreas: false,
  tsuAreas: [],
  tsuFetchedRunupCountries: false,
  tsuRunupCountries: [],
  tsuFetchingRunupAreas: false,
  tsuRunupAreas: [],
  tsuFetchedRunupMeasurementTypes: false,
  tsuRunupMeasurementTypes: [],
  tsuFetchedValidities: false,
  tsuValidities: [],
  tsuFetchedCauses: false,
  tsuCauses: [],

  depFetchedPublications: false,
  depPublications: [],
  depFetchedGeologicAges: false,
  depGeologicAges: [],
  depFetchedBodiesOfWater: false,
  depBodiesOfWater: [],
  depFetchedCountries: false,
  depCountries: [],

  runupFetchedRegions: false,
  runupRegions: [],
  runupFetchedCountries: false,
  runupCountries: [],
  runupFetchingAreas: false,
  runupAreas: [],
  runupFetchedRunupCountries: false,
  runupRunupCountries: [],
  runupFetchingRunupAreas: false,
  runupRunupAreas: [],
  runupFetchedRunupMeasurementTypes: false,
  runupRunupMeasurementTypes: [],
  runupFetchedCauses: false,
  runupCauses: [],
  runupFetchedValidities: false,
  runupValidities: [],

  sort,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const referenceSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFERENCE_SEARCH_CLEAR_REDIRECT:
      return state.set('searchRedirect', false);
    case REFERENCE_SEARCH_CLEAR:
      return initialState.set('sort', state.get('sort'));

    case REFERENCE_DATA_SORT:
      return state.merge(fromJS({
        references: basicSort(action.sort, state.get('references')),
        sort: action.sort,
      }));

    case REFERENCE_SEARCH_REQUEST:
      return state.merge(fromJS({
        searching: true,
        fetched: false,
        queryParameters: action.queryParameters,
        searchRedirect: Boolean(action.searchRedirect),
      }));
    case REFERENCE_SEARCH_SUCCESS:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
        references: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case REFERENCE_SEARCH_FAILURE:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
      }));

    case REFERENCE_HAVE_REQUEST:
      return state.merge(fromJS({
        fetchedHaves: false,
      }));
    case REFERENCE_HAVE_SUCCESS:
      return state.merge(fromJS({
        fetchedHaves: true,
        haves: action.response.items,
      }));
    case REFERENCE_HAVE_FAILURE:
      return state.merge(fromJS({
        fetchedHaves: true,
      }));

    // Associated Hazards
    case REFERENCE_SEARCH_EQ_REGION_REQUEST:
      return state.merge(fromJS({
        eqFetchedRegions: false,
      }));
    case REFERENCE_SEARCH_EQ_REGION_SUCCESS:
      return state.merge(fromJS({
        eqFetchedRegions: true,
        eqRegions: action.response.items,
      }));
    case REFERENCE_SEARCH_EQ_REGION_FAILURE:
      return state.merge(fromJS({
        eqFetchedRegions: true,
      }));

    case REFERENCE_SEARCH_EQ_COUNTRY_REQUEST:
      return state.merge(fromJS({
        eqFetchedCountries: false,
      }));
    case REFERENCE_SEARCH_EQ_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        eqFetchedCountries: true,
        eqCountries: action.response.items,
      }));
    case REFERENCE_SEARCH_EQ_COUNTRY_FAILURE:
      return state.merge(fromJS({
        eqFetchedCountries: true,
      }));

    case REFERENCE_SEARCH_EQ_AREA_REQUEST:
      return state.merge(fromJS({
        eqFetchingAreas: true,
      }));
    case REFERENCE_SEARCH_EQ_AREA_SUCCESS:
      return state.merge(fromJS({
        eqFetchingAreas: false,
        eqAreas: action.response.items,
      }));
    case REFERENCE_SEARCH_EQ_AREA_FAILURE:
      return state.merge(fromJS({
        eqFetchingAreas: false,
        eqAreas: initialState.get('eqAreas'),
      }));

    case REFERENCE_SEARCH_VOL_COUNTRY_REQUEST:
      return state.merge(fromJS({
        volFetchedCountries: false,
      }));
    case REFERENCE_SEARCH_VOL_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        volFetchedCountries: true,
        volCountries: action.response.items,
      }));
    case REFERENCE_SEARCH_VOL_COUNTRY_FAILURE:
      return state.merge(fromJS({
        volFetchedCountries: true,
      }));

    case REFERENCE_SEARCH_VOL_REGION_REQUEST:
      return state.merge(fromJS({
        volFetchedRegions: false,
      }));
    case REFERENCE_SEARCH_VOL_REGION_SUCCESS:
      return state.merge(fromJS({
        volFetchedRegions: true,
        volRegions: action.response.items,
      }));
    case REFERENCE_SEARCH_VOL_REGION_FAILURE:
      return state.merge(fromJS({
        volFetchedRegions: true,
      }));

    case REFERENCE_SEARCH_VOL_VOLCANO_NAMES_REQUEST:
      return state.merge(fromJS({
        volFetchedVolcanoNames: false,
      }));
    case REFERENCE_SEARCH_VOL_VOLCANO_NAMES_SUCCESS:
      return state.merge(fromJS({
        volFetchedVolcanoNames: true,
        volVolcanoNames: action.response.items,
      }));
    case REFERENCE_SEARCH_VOL_VOLCANO_NAMES_FAILURE:
      return state.merge(fromJS({
        volVolcanoNames: true,
      }));

    case REFERENCE_SEARCH_VOL_MORPHOLOGIES_REQUEST:
      return state.merge(fromJS({
        volFetchedMorphologies: false,
      }));
    case REFERENCE_SEARCH_VOL_MORPHOLOGIES_SUCCESS:
      return state.merge(fromJS({
        volFetchedMorphologies: true,
        volMorphologies: action.response.items,
      }));
    case REFERENCE_SEARCH_VOL_MORPHOLOGIES_FAILURE:
      return state.merge(fromJS({
        volFetchedMorphologies: true,
      }));

    case REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_REQUEST:
      return state.merge(fromJS({
        volLocFetchedRegions: false,
      }));
    case REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_SUCCESS:
      return state.merge(fromJS({
        volLocFetchedRegions: true,
        volLocRegions: action.response.items,
      }));
    case REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_FAILURE:
      return state.merge(fromJS({
        volLocFetchedRegions: true,
      }));

    case REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_REQUEST:
      return state.merge(fromJS({
        volLocFetchedCountries: false,
      }));
    case REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        volLocFetchedCountries: true,
        volLocCountries: action.response.items,
      }));
    case REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_FAILURE:
      return state.merge(fromJS({
        volLocFetchedCountries: true,
      }));

    case REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST:
      return state.merge(fromJS({
        volLocFetchedEruptionTimes: false,
      }));
    case REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_SUCCESS:
      return state.merge(fromJS({
        volLocFetchedEruptionTimes: true,
        volLocEruptionTimes: action.response.items,
      }));
    case REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_FAILURE:
      return state.merge(fromJS({
        volLocFetchedEruptionTimes: true,
      }));

    case REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_REQUEST:
      return state.merge(fromJS({
        volLocFetchedMorphologies: false,
      }));
    case REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_SUCCESS:
      return state.merge(fromJS({
        volLocFetchedMorphologies: true,
        volLocMorphologies: action.response.items,
      }));
    case REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_FAILURE:
      return state.merge(fromJS({
        volLocFetchedMorphologies: true,
      }));

    case REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_REQUEST:
      return state.merge(fromJS({
        volLocFetchedStatuses: false,
      }));
    case REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_SUCCESS:
      return state.merge(fromJS({
        volLocFetchedStatuses: true,
        volLocStatuses: action.response.items,
      }));
    case REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_FAILURE:
      return state.merge(fromJS({
        volLocFetchedStatuses: true,
      }));

    case REFERENCE_SEARCH_TSUNAMI_REGIONS_REQUEST:
      return state.merge(fromJS({
        tsuFetchedRegions: false,
      }));
    case REFERENCE_SEARCH_TSUNAMI_REGIONS_SUCCESS:
      return state.merge(fromJS({
        tsuFetchedRegions: true,
        tsuRegions: action.response.items,
      }));
    case REFERENCE_SEARCH_TSUNAMI_REGIONS_FAILURE:
      return state.merge(fromJS({
        tsuFetchedRegions: true,
      }));

    case REFERENCE_SEARCH_TSUNAMI_COUNTRIES_REQUEST:
      return state.merge(fromJS({
        tsuFetchedCountries: false,
      }));
    case REFERENCE_SEARCH_TSUNAMI_COUNTRIES_SUCCESS:
      return state.merge(fromJS({
        tsuFetchedCountries: true,
        tsuCountries: action.response.items,
      }));
    case REFERENCE_SEARCH_TSUNAMI_COUNTRIES_FAILURE:
      return state.merge(fromJS({
        tsuFetchedCountries: true,
      }));

    case REFERENCE_SEARCH_TSUNAMI_AREAS_REQUEST:
      return state.merge(fromJS({
        tsuFetchingAreas: true,
      }));
    case REFERENCE_SEARCH_TSUNAMI_AREAS_SUCCESS:
      return state.merge(fromJS({
        tsuFetchingAreas: false,
        tsuAreas: action.response.items,
      }));
    case REFERENCE_SEARCH_TSUNAMI_AREAS_FAILURE:
      return state.merge(fromJS({
        tsuFetchingAreas: false,
        // tsuAreas: initialState.get('tsuAreas'),
      }));

    case REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_REQUEST:
      return state.merge(fromJS({
        tsuFetchedRunupCountries: false,
      }));
    case REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_SUCCESS:
      return state.merge(fromJS({
        tsuFetchedRunupCountries: true,
        tsuRunupCountries: action.response.items,
      }));
    case REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_FAILURE:
      return state.merge(fromJS({
        tsuFetchedRunupCountries: true,
      }));

    case REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_REQUEST:
      return state.merge(fromJS({
        tsuFetchingRunupAreas: true,
      }));
    case REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_SUCCESS:
      return state.merge(fromJS({
        tsuFetchingRunupAreas: false,
        tsuRunupAreas: action.response.items,
      }));
    case REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_FAILURE:
      return state.merge(fromJS({
        tsuFetchingRunupAreas: false,
        // tsuRunupAreas: initialState.get('tsuAreas'),
      }));

    case REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_REQUEST:
      return state.merge(fromJS({
        tsuFetchedRunupMeasurementTypes: false,
      }));
    case REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_SUCCESS:
      return state.merge(fromJS({
        tsuFetchedRunupMeasurementTypes: true,
        tsuRunupMeasurementTypes: action.response.items,
      }));
    case REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_FAILURE:
      return state.merge(fromJS({
        tsuFetchedRunupMeasurementTypes: true,
      }));

    case REFERENCE_SEARCH_TSUNAMI_VALIDITIES_REQUEST:
      return state.merge(fromJS({
        tsuFetchedValidities: false,
      }));
    case REFERENCE_SEARCH_TSUNAMI_VALIDITIES_SUCCESS:
      return state.merge(fromJS({
        tsuFetchedValidities: true,
        tsuValidities: action.response.items,
      }));
    case REFERENCE_SEARCH_TSUNAMI_VALIDITIES_FAILURE:
      return state.merge(fromJS({
        tsuFetchedValidities: true,
      }));

    case REFERENCE_SEARCH_TSUNAMI_CAUSES_REQUEST:
      return state.merge(fromJS({
        tsuFetchedCauses: false,
      }));
    case REFERENCE_SEARCH_TSUNAMI_CAUSES_SUCCESS:
      return state.merge(fromJS({
        tsuFetchedCauses: true,
        tsuCauses: action.response.items,
      }));
    case REFERENCE_SEARCH_TSUNAMI_CAUSES_FAILURE:
      return state.merge(fromJS({
        tsuFetchedCauses: true,
      }));

    case REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_REQUEST:
      return state.merge(fromJS({
        depFetchedPublications: false,
      }));
    case REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_SUCCESS:
      return state.merge(fromJS({
        depFetchedPublications: true,
        depPublications: action.response.items,
      }));
    case REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_FAILURE:
      return state.merge(fromJS({
        depFetchedPublications: true,
      }));

    case REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_REQUEST:
      return state.merge(fromJS({
        depFetchedGeologicAges: false,
      }));
    case REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_SUCCESS:
      return state.merge(fromJS({
        depFetchedGeologicAges: true,
        depGeologicAges: action.response.items,
      }));
    case REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_FAILURE:
      return state.merge(fromJS({
        depFetchedGeologicAges: true,
      }));

    case REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_REQUEST:
      return state.merge(fromJS({
        depFetchedBodiesOfWater: false,
      }));
    case REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_SUCCESS:
      return state.merge(fromJS({
        depFetchedBodiesOfWater: true,
        depBodiesOfWater: action.response.items,
      }));
    case REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_FAILURE:
      return state.merge(fromJS({
        depFetchedBodiesOfWater: true,
      }));

    case REFERENCE_SEARCH_DEPOSIT_COUNTRIES_REQUEST:
      return state.merge(fromJS({
        depFetchedCountries: false,
      }));
    case REFERENCE_SEARCH_DEPOSIT_COUNTRIES_SUCCESS:
      return state.merge(fromJS({
        depFetchedCountries: true,
        depCountries: action.response.items,
      }));
    case REFERENCE_SEARCH_DEPOSIT_COUNTRIES_FAILURE:
      return state.merge(fromJS({
        depFetchedCountries: true,
      }));

    case REFERENCE_SEARCH_RUNUP_REGIONS_REQUEST:
      return state.merge(fromJS({
        runupFetchedRegions: false,
      }));
    case REFERENCE_SEARCH_RUNUP_REGIONS_SUCCESS:
      return state.merge(fromJS({
        runupFetchedRegions: true,
        runupRegions: action.response.items,
      }));
    case REFERENCE_SEARCH_RUNUP_REGIONS_FAILURE:
      return state.merge(fromJS({
        runupFetchedRegions: true,
      }));

    case REFERENCE_SEARCH_RUNUP_COUNTRIES_REQUEST:
      return state.merge(fromJS({
        runupFetchedCountries: false,
      }));
    case REFERENCE_SEARCH_RUNUP_COUNTRIES_SUCCESS:
      return state.merge(fromJS({
        runupFetchedCountries: true,
        runupCountries: action.response.items,
      }));
    case REFERENCE_SEARCH_RUNUP_COUNTRIES_FAILURE:
      return state.merge(fromJS({
        runupFetchedCountries: true,
      }));

    case REFERENCE_SEARCH_RUNUP_AREAS_REQUEST:
      return state.merge(fromJS({
        runupFetchingAreas: true,
      }));
    case REFERENCE_SEARCH_RUNUP_AREAS_SUCCESS:
      return state.merge(fromJS({
        runupFetchingAreas: false,
        runupAreas: action.response.items,
      }));
    case REFERENCE_SEARCH_RUNUP_AREAS_FAILURE:
      return state.merge(fromJS({
        runupFetchingAreas: false,
      }));

    case REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_REQUEST:
      return state.merge(fromJS({
        runupFetchedRunupCountries: false,
      }));
    case REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_SUCCESS:
      return state.merge(fromJS({
        runupFetchedRunupCountries: true,
        runupRunupCountries: action.response.items,
      }));
    case REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_FAILURE:
      return state.merge(fromJS({
        runupFetchedRunupCountries: true,
      }));

    case REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_REQUEST:
      return state.merge(fromJS({
        runupFetchingRunupAreas: true,
      }));
    case REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_SUCCESS:
      return state.merge(fromJS({
        runupFetchingRunupAreas: false,
        runupRunupAreas: action.response.items,
      }));
    case REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_FAILURE:
      return state.merge(fromJS({
        runupFetchingRunupAreas: false,
      }));

    case REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_REQUEST:
      return state.merge(fromJS({
        runupFetchedRunupMeasurementTypes: false,
      }));
    case REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_SUCCESS:
      return state.merge(fromJS({
        runupFetchedRunupMeasurementTypes: true,
        runupRunupMeasurementTypes: action.response.items,
      }));
    case REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_FAILURE:
      return state.merge(fromJS({
        runupFetchedRunupMeasurementTypes: true,
      }));

    case REFERENCE_SEARCH_RUNUP_CAUSES_REQUEST:
      return state.merge(fromJS({
        runupFetchedCauses: false,
      }));
    case REFERENCE_SEARCH_RUNUP_CAUSES_SUCCESS:
      return state.merge(fromJS({
        runupFetchedCauses: true,
        runupCauses: action.response.items,
      }));
    case REFERENCE_SEARCH_RUNUP_CAUSES_FAILURE:
      return state.merge(fromJS({
        runupFetchedCauses: true,
      }));

    case REFERENCE_SEARCH_RUNUP_VALIDITIES_REQUEST:
      return state.merge(fromJS({
        runupFetchedValidities: false,
      }));
    case REFERENCE_SEARCH_RUNUP_VALIDITIES_SUCCESS:
      return state.merge(fromJS({
        runupFetchedValidities: true,
        runupValidities: action.response.items,
      }));
    case REFERENCE_SEARCH_RUNUP_VALIDITIES_FAILURE:
      return state.merge(fromJS({
        runupFetchedValidities: true,
      }));

    default:
      return state;
  }
};
